import { Helmet } from "react-helmet-async";

export default function HandbookPage() {
  return (
    <>
      <Helmet>
        <title>dot. by PathologyWatch Handbook</title>
      </Helmet>
      <div className="HandbookPage">
        <iframe
          title="handbook"
          src="https://drive.google.com/file/d/1-AkWGkRe5l9oR1lMR6wYv3gUygCmr4xY/preview"
        />
      </div>
    </>
  );
}
